import { StyleConfig, LayoutConfig } from '../types/component'

/**
 * Convert StyleConfig to React CSSProperties
 */
export function getStyleFromConfig(
  style: StyleConfig = {},
  layout: LayoutConfig = {}
): React.CSSProperties {
  const cssProperties: React.CSSProperties = {}

  // Apply style config
  Object.entries(style).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      // Handle backgroundGradient specially - apply as 'background'
      if (key === 'backgroundGradient') {
        cssProperties.background = value as string
      } else if (key !== 'backgroundColor' || !style.backgroundGradient) {
        // Only apply backgroundColor if there's no backgroundGradient
        ;(cssProperties as any)[key] = value
      }
    }
  })

  // Apply layout config
  if (layout.width) cssProperties.width = layout.width
  if (layout.height) cssProperties.height = layout.height
  if (layout.minHeight) cssProperties.minHeight = layout.minHeight
  if (layout.maxWidth) cssProperties.maxWidth = layout.maxWidth
  if (layout.display) cssProperties.display = layout.display
  if (layout.flexDirection) cssProperties.flexDirection = layout.flexDirection
  if (layout.justifyContent) cssProperties.justifyContent = layout.justifyContent
  if (layout.alignItems) cssProperties.alignItems = layout.alignItems
  if (layout.gap) cssProperties.gap = `${layout.gap}px`

  // Position
  if (layout.position) {
    cssProperties.position = layout.position
    if (layout.position === 'absolute') {
      if (layout.x !== undefined) cssProperties.left = `${layout.x}px`
      if (layout.y !== undefined) cssProperties.top = `${layout.y}px`
    }
  }

  // Padding
  if (layout.padding) {
    cssProperties.paddingTop = layout.padding.top ? `${layout.padding.top}px` : undefined
    cssProperties.paddingRight = layout.padding.right ? `${layout.padding.right}px` : undefined
    cssProperties.paddingBottom = layout.padding.bottom ? `${layout.padding.bottom}px` : undefined
    cssProperties.paddingLeft = layout.padding.left ? `${layout.padding.left}px` : undefined
  }

  // Margin
  if (layout.margin) {
    cssProperties.marginTop =
      layout.margin.top === 'auto' ? 'auto' : layout.margin.top ? `${layout.margin.top}px` : undefined
    cssProperties.marginRight =
      layout.margin.right === 'auto' ? 'auto' : layout.margin.right ? `${layout.margin.right}px` : undefined
    cssProperties.marginBottom =
      layout.margin.bottom === 'auto' ? 'auto' : layout.margin.bottom ? `${layout.margin.bottom}px` : undefined
    cssProperties.marginLeft =
      layout.margin.left === 'auto' ? 'auto' : layout.margin.left ? `${layout.margin.left}px` : undefined
  }

  return cssProperties
}
